import React, { useEffect, useState } from 'react';
import Loader from '../Layout/Loader';
import Table from '@material-ui/core/Table';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import LLDRentRow from './LLDRentRow';
import KobooTablePagination from '../Layout/KobooTablePagination';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { getDateAsString, getDayLastSecondeDate } from '../../services/DateService';
import { longLocationTypes } from '../../constants/LongLocationType';
import StringService from '../../services/StringService';
import Typography from '@material-ui/core/Typography';

const columnData = [
  {
    id: 'state',
    numeric: false,
    disablePadding: false,
    label: 'État',
  },
  {
    id: 'renter_name',
    numeric: false,
    disablePadding: false,
    label: 'Loueur',
  },
  {
    id: 'site_name',
    numeric: false,
    disablePadding: false,
    label: 'Site départ',
  },
  {
    id: 'client',
    numeric: false,
    disablePadding: false,
    label: 'Client',
  },
  {
    id: 'start_date',
    numeric: false,
    disablePadding: false,
    label: 'Date de début',
  },
  {
    id: 'duration',
    numeric: false,
    disablePadding: false,
    label: 'Durée de location',
  },
  {
    id: 'is_electric',
    numeric: false,
    disablePadding: false,
    label: 'Type de vélo',
  },
  {
    id: 'bike_number',
    numeric: true,
    disablePadding: false,
    label: 'Numéro du Vélo',
  },
  {
    id: 'start_inventory',
    numeric: true,
    disablePadding: false,
    label: 'État des lieux début',
    disableSorting: true,
  },
  {
    id: 'end_inventory',
    numeric: true,
    disablePadding: false,
    label: 'État des lieux fin',
    disableSorting: true,
  },
];

const styles = theme => (
  {
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    table: {
      minWidth: 700,
    },
    emptyLabel: {
      marginLeft: '10px',
    },
  }
);

const objectsToTableData = (objects) => {
  let end = getDayLastSecondeDate();
  return objects.map(obj => {
      let state = 1; // à cloturer
      if (obj.end_date !== null) {
        state = 2; // cloturé
      } else if (obj.long_rent_end_date > (
        end.getTime() / 1000
      )) {
        state = 0; // loué
      }
      const startDate = new Date(obj.start_date * 1000);
      const lltCount = obj.book.long_location_duration.long_location_type.count;
      const lltType = obj.book.long_location_duration.long_location_type.type;
      const duration = lltCount
        + ' '
        + longLocationTypes[lltType]
        + (
          (
            lltCount > 1 && lltType !== 'month'
          )
            ? 's'
            : ''
        );
      let firstname = '';
      let lastname = '';
      if (typeof obj.username === 'string') {
        const usernameSplit = obj.username.split(' ');
        if (usernameSplit.length > 1) {
          firstname = usernameSplit[0];
          lastname = usernameSplit[1];
        } else {
          lastname = obj.username;
        }
      }

      return {
        id: obj.id,
        book_id: obj.book.id,
        start_date: obj.start_date,
        end_date: obj.end_date,
        long_rent_end_date: obj.long_rent_end_date,
        start_inventory: obj.book.start_inventory,
        end_inventory: obj.end_inventory,
        start_site_name: obj.start_site.name,
        renter_info_name: obj.start_site.renter_info_name,
        start_date_string: getDateAsString(startDate),
        firstname,
        lastname,
        bike_number: obj.bike_number,
        duration: duration,
        is_electric: obj.book.is_electric
          ? 'Électrique'
          : 'Mécanique',
        state: state,
        original: obj,
      };
    },
  );
};

const LldRentsTable = (props) => {
  const {
    rents,
    pending,
    openDialog,
    classes,
    authUser,
    error,
    roles,
  } = props;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('start_date');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [tableData, setTableData] = useState([]);

  let role = ROLE_USER;
  if (roles && authUser && roles[authUser.uid]) {
    role = roles[authUser.uid];
  }

  let columns = [...columnData];
  if (role < ROLE_ADMIN) {
    columns.splice(columnData.findIndex(column => column.id === 'renter_name'), 1);
  }

  useEffect(() => {
    setTableData(objectsToTableData(props.rents));
    sortTableData();
  }, [rents]);

  const sortTableData = () => {
    tableData.sort((firstEl, secondEl) => {

      let prop1,
        prop2;
      if (orderBy === 'renter_name') {
        prop1 = firstEl.renter_info_name;
        prop2 = secondEl.renter_info_name;
      } else if (orderBy === 'site_name') {
        prop1 = firstEl.start_site_name;
        prop2 = secondEl.start_site_name;
      } else if (orderBy === 'client') {
        prop1 = StringService.formatClientName(firstEl.lastname, firstEl.firstname);
        prop2 = StringService.formatClientName(secondEl.lastname, secondEl.firstname);
      } else {
        prop1 = firstEl[orderBy];
        prop2 = secondEl[orderBy];
      }
      if (prop1 < prop2) {
        return -1;
      } else if (prop1 > prop2) {
        return 1;
      }
      return 0;
    });
    if (order === 'desc') {
      tableData.reverse();
    }
  };

  const handleChangeOrder = property => {
    const newOrderBy = property;
    let newOrder = 'asc';
    if (orderBy === newOrderBy && order === newOrder) {
      newOrder = 'desc';
    }
    setOrder(newOrder);
    setOrderBy(newOrderBy);
  };

  const handleChangePage = page => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  if (!pending && rents && rents.length > 0) {
    sortTableData();
  }

  return (
    <React.Fragment>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {columns.map(column => (
              <TableCell
                key={column.id}
                padding={column.disablePadding
                  ? 'none'
                  : 'normal'}
                sortDirection={orderBy === column.id
                  ? order
                  : false}>
                {!column.disableSorting && <Tooltip
                  title="Trier"
                  placement={column.numeric
                    ? 'bottom-end'
                    : 'bottom-start'}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={() => handleChangeOrder(column.id)}>
                    {column.label}
                  </TableSortLabel>
                </Tooltip>}
                {column.disableSorting
                && <Typography variant={'body2'} style={{ fontWeight: 500 }}>
                  {column.label}
                </Typography>}
              </TableCell>
            ), this)}
          </TableRow>
        </TableHead>
        <TableBody>
          {pending &&
          <tr>
            <td colSpan={columns.length}>
              <Loader />
            </td>
          </tr>}

          {!pending && rents && rents.length > 0 &&
          tableData.slice(page * rowsPerPage,
            (
              page * rowsPerPage
            ) + rowsPerPage,
          ).map(rent => (
            <LLDRentRow
              key={rent.id}
              rent={rent}
              openDialog={openDialog}
              authUser={authUser}
              error={error}
              role={role}
            />
          ))}

          {!pending && rents && rents.length <= 0 &&
          <tr>
            <td colSpan={columns.length}>
              <Typography style={{ textAlign: 'center' }} variant="subtitle1">
                Aucune locations
              </Typography>
            </td>
          </tr>
          }
        </TableBody>
      </Table>
      <KobooTablePagination
        numberOfItems={rents.length}
        rowsPerPage={rowsPerPage}
        label="Locations par page"
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    error: state.rentsLld.error,
    roles: state.roles.content,
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(LldRentsTable);



// WEBPACK FOOTER //
// ./src/components/LldRent/LldRentsTable.jsx